export const MAX_LUMBERJACKS = 6;
export const MAX_SAWMILLERS = 4;
export const MAX_FORESTERS = 4;
export const MAX_BUILDERS = 6;
export const MAX_QUARRYMEN = 4;
export const MAX_MASONS = 3;
export const MAX_BURNERS = 3;
export const MAX_MINERS = 4;
export const MAX_SMELTERS = 3;
export const MAX_WEAVERS = 2;
export const MAX_FISHERS = 3;
export const MAX_SMOKERS = 1;
export const MAX_SMITHS = 2;
export const MAX_GOLD_MINERS = 2;
export const MAX_MINTERS = 2;
export const MAX_MILITIA = 6;
